import React from 'react';
import { Box, LucideIcon, Text, useBreakpointValue } from '@skin-seoul/design-system';
import { formatCurrency, useProductService, useRegionCurrency } from '@skin-seoul/service';
import SectionContainer from '../../components/SectionContainer';
import { useParams } from 'next/navigation';
const FreeShippingSection = () => {
  const {
    useGetProductsDetail
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const params = useParams();
  const {
    data: {
      shippingPolicy
    }
  } = useGetProductsDetail({
    slug: params.slug as string,
    currency
  });
  const showTopBorder = useBreakpointValue({
    base: true,
    tablet: false
  });
  return <SectionContainer headerTitle={`Delivery in ${shippingPolicy.minDeliveryDays} - ${shippingPolicy.maxDeliveryDays} business days`} sectionInnerProps={{
    gap: 3,
    width: '100%'
  }} showTopBorder={showTopBorder} data-sentry-element="SectionContainer" data-sentry-component="FreeShippingSection" data-sentry-source-file="FreeShippingSection.tsx">
      <Box borderRadius="4px" backgroundColor="neutral.50" padding={3} display="flex" gap={1} width="100%" alignItems="flex-start" data-sentry-element="Box" data-sentry-source-file="FreeShippingSection.tsx">
        <LucideIcon className="neutral.600" name="CircleAlert" boxSize={4} data-sentry-element="LucideIcon" data-sentry-source-file="FreeShippingSection.tsx" />
        <Text textStyle="label.medium" fontWeight="medium" color="neutral.600" data-sentry-element="Text" data-sentry-source-file="FreeShippingSection.tsx">
          Latest Korean beauty releases imported directly from Seoul — authentic, current, and fresh from the source.
        </Text>
      </Box>
      <Box width="100%" height={{
      base: '74px',
      tablet: '92px'
    }} background="linear-gradient(90deg, #5645AF 0%, #000000 30%)" borderRadius="8px" position="relative" overflow="hidden" data-sentry-element="Box" data-sentry-source-file="FreeShippingSection.tsx">
        {/* Main Text */}
        <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" display="flex" alignItems="center" justifyContent="center" width="100%" flexDirection="column" gap={2} paddingX={4} data-sentry-element="Box" data-sentry-source-file="FreeShippingSection.tsx">
          <Text textStyle={{
          base: 'label.large',
          tablet: 'heading.h6'
        }} color="white" fontWeight="semibold" letterSpacing={{
          tablet: '-0.4px'
        }} textAlign="center" data-sentry-element="Text" data-sentry-source-file="FreeShippingSection.tsx">
            {`Spend ${formatCurrency(currency, shippingPolicy.freeShippingThreshold).replace(/\.\d{2}/, '')} and get Free Shipping`}
          </Text>

          {/* Sub Text */}
          <Text textStyle={{
          base: 'label.small',
          tablet: 'label.medium'
        }} color="neutral.100" fontWeight="medium" textAlign="center" data-sentry-element="Text" data-sentry-source-file="FreeShippingSection.tsx">
            <Text as="span" fontWeight="semibold" color="neutral.50" data-sentry-element="Text" data-sentry-source-file="FreeShippingSection.tsx">
              Register
            </Text>
            {' to Unlock Free Shipping for 1st Order'}
          </Text>
        </Box>
      </Box>
    </SectionContainer>;
};
export default FreeShippingSection;